/** Name of the feature. */
export const StandardConnect = 'standard:connect';
/**
 * @deprecated Use {@link StandardConnect} instead.
 *
 * @group Deprecated
 */
export const Connect = StandardConnect;
//# sourceMappingURL=connect.js.map